import React from "react";

import DropDownBox, {
  IDropDownBoxOptions,
} from "devextreme-react/drop-down-box";
import DataGrid, {
  Selection,
  Paging,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid";
import "devextreme-react/data-grid";
import "devextreme-react/drop-down-box";

interface DropdownGridProps extends IDropDownBoxOptions {
  dataSource: any[];
  columns: any[];
  displayExpr: string;
  value: string | number;
  selectionMode?: "single" | "multiple" | undefined;
  returnSelectedId: (id: string) => void;
}

const DropdownGrid = ({
  displayExpr,
  value,
  dataSource,
  columns,
  selectionMode = "single",
  returnSelectedId,
  ...rest
}: DropdownGridProps) => {
  const grid_itemSelectionChanged = (e: any) => {
    selectionMode === "single"
      ? e.currentSelectedRowKeys.length > 0 &&
        returnSelectedId(e.currentSelectedRowKeys[0])
      : e.currentSelectedRowKeys.length > 0 &&
        returnSelectedId(e.currentSelectedRowKeys);
  };

  const gridRender = () => {
    return (
      <DataGrid
        keyExpr="Id"
        //@ts-ignore
        dataSource={dataSource}
        columns={columns}
        hoverStateEnabled={true}
        selectedRowKeys={[value]}
        onSelectionChanged={grid_itemSelectionChanged}
        showBorders
        height="100%"
      >
        <Selection mode={selectionMode} />
        <Scrolling mode="virtual" />
        <Paging enabled={true} pageSize={10} />
        <FilterRow visible={true} />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      //@ts-ignore
      dataSource={dataSource}
      value={value}
      valueExpr="Id"
      displayExpr={displayExpr}
      contentRender={gridRender}
      {...rest}
    />
  );
};

export default DropdownGrid;
